import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Login from "./views/Login.js"
import ToolUse from "./views/ToolUse.js"
import { Route, Routes, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation.js"
import MyDrawer from "./components/Drawer.js"
import AddTool from "./views/addTool.js"
import MainPage from "./views/mainPage.js"
import toolsApi from './services/toolsApi.js';
import ToolManagement from './views/ToolManagement.js';
import UserManagement from "./views/UserManagement.js"
import AdminPage from './views/AdminPage.js';
import useMediaQuery from '@mui/material/useMediaQuery';
import FeedbackButton from './components/FeedbackButton.js';
import Feedback from './components/Feedback.js';
import About from './views/About.js';
import { useTheme } from '@mui/material/styles';
import NotFound from "./components/NotFound"
import ReactGA from "react-ga4";

ReactGA.initialize("G-3RZMD179KE");

const DRAWER_WIDTH = 280;

function App() {
  const location = useLocation();
  const theme = useTheme();
  const isMainPage = location.pathname === "/";
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [mobileOpen, setMobileOpen] = useState(false);
  const [tools, setTools] = useState([]);
  const [openFeedback, setOpenFeedback] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  useEffect(() => {
    const fetchTools = async () => {
      const data = await toolsApi.getTools();
      setTools(data);
    };
    fetchTools();
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Navigation handleDrawerToggle={handleDrawerToggle} />
      
      <MyDrawer 
        tools={tools} 
        mobileOpen={mobileOpen} 
        handleDrawerToggle={handleDrawerToggle} 
        drawerWidth={DRAWER_WIDTH} 
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          mt: '64px',
          bgcolor: isMainPage ? 'transparent' : 'background.paper',
          transition: 'all 0.3s ease',
          minWidth: 0 // Prevent flex overflow
        }}
      >
        <Routes>
          <Route exact path="/login" element={<Login />} />
          {tools.map((tool) => (
            <Route 
              key={tool.enum} 
              path={"/" + tool.enum}
              element={<ToolUse tool={tool} tools={tools} />}
            />
          ))}
          <Route path="/" exact element={<MainPage tools={tools} />} />
          <Route path="/about" element={<About />} />
          
          <Route path="/manageUsers" element={<UserManagement />} />
          <Route path="/manageTools" element={<ToolManagement />} />
          <Route path="/addTool" element={<AddTool />} />
          <Route path="/panel" element={<AdminPage />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>

      <Feedback open={openFeedback} setOpen={setOpenFeedback} />
      <FeedbackButton onClick={() => setOpenFeedback(true)} />
    </Box>
  );
}

export default App;
